/**
 * Shared SWR options for AICC data hooks.
 *
 * Every option here is a deliberate departure from an SWR default, because the
 * defaults fight two things in this codebase:
 *
 * - `aiccInstance` (utils/instance.ts) already toasts on failure via
 *   `aiccErrorHandler`. SWR retries failed requests ~5 times by default, so each
 *   broken endpoint would stack up that many error toasts. Hence
 *   `shouldRetryOnError: false` — the hook surfaces `isError` and the interceptor
 *   has already told the user.
 * - This is an internal admin portal: data does not change often enough to justify
 *   refetching every time the operator switches browser tabs. Hence the two
 *   `revalidateOn*` opt-outs.
 *
 * Note `aiccSilentNotFoundUrls` in utils/instance.ts resolves a 404 GET to
 * `undefined` for a few endpoints, so "absent" is a legal value. Consumers must
 * distinguish loading from legitimately-empty — branch on `isLoading` first, not
 * on `!data`, or the first render flashes an empty state.
 *
 * Deliberately untyped: importing SWR's `SWRConfiguration` type pulls
 * swr@2.2.5's `.d.ts` into the TS 4.1 parser, which chokes on its
 * `export { type X }` syntax (TS 4.5+). `useBillingPlans.ts` sidesteps this the
 * same way — value imports from "swr" only, never type imports. `useSWR` still
 * typechecks these options structurally at the call site.
 */
export const AICC_SWR_CONFIG = {
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
  shouldRetryOnError: false,
  dedupingInterval: 5000,
};
